import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// NOTE: `beforeinstallprompt` is captured by an inline script in public/index.html <head>
// (runs before this bundle) and stashed on window.__deferredInstallPrompt. Do NOT reset it here.

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// PWA service worker registration + auto-update to newest deploy.
if ("serviceWorker" in navigator) {
  let refreshing = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (refreshing) return;
    refreshing = true;
    window.location.reload();
  });
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").then((reg) => {
      // Check for a newer service worker on every load.
      reg.update().catch(() => {});
      reg.addEventListener("updatefound", () => {
        const nw = reg.installing;
        if (!nw) return;
        nw.addEventListener("statechange", () => {
          if (nw.state === "installed" && navigator.serviceWorker.controller) {
            nw.postMessage("SKIP_WAITING");
          }
        });
      });
    }).catch(() => {});
  });
}
